import { render, staticRenderFns } from "./docmanager.vue?vue&type=template&id=d6281edc&scoped=true&"
import script from "./docmanager.vue?vue&type=script&lang=js&"
export * from "./docmanager.vue?vue&type=script&lang=js&"
import style0 from "./docmanager.vue?vue&type=style&index=0&id=d6281edc&lang=less&scoped=true&"
import style1 from "./docmanager.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6281edc",
  null
  
)

export default component.exports